import { homePageReducer } from 'components/HomePage/redux/reducer';
import { currentScrollEventReducer } from './currentScrollEventReducer';
import { fieldStatsReducer } from './fieldStatsReducer';
import { filterReducer } from './filterReducer';
import { histogramReducer } from './histogramReducer';
import { localeReducer } from './localeReducer';
import { locationReducer } from './locationReducer';
import { uiStateReducer } from './uiStateReducer';

// Add a reducer to this export to make it automagically part of the store.
export default {
  histogram: histogramReducer,
  homepage: homePageReducer,
  currentScrollEvent: currentScrollEventReducer,
  filter: filterReducer,
  uiState: uiStateReducer,
  locationState: locationReducer,
  localeState: localeReducer,
  fieldStats: fieldStatsReducer,
};
